import React, { useCallback, useContext } from 'react';
import I18nContext from '../../contexts/i18n';
import { arTranslations, elTranslations } from '@lemonadefashion/localization-data';
import { useTokenTranslate } from '../../contexts/token_translation_context';

export const useTranslation = () => {
  const i18nSettings = useContext(I18nContext);
  const locale = i18nSettings.getLocale();

  const tFn = useCallback((text) => {
    if (text == null) return text;
    const normalizedText = (text || '').trim().toLowerCase();
    if (locale.startsWith('en')) return text;
    if (locale.startsWith('ar')) {
      const translation = arTranslations[normalizedText];
      // If there is no translation, we just return the text as is.
      if (translation == null) return text;
      return translation;
    }
    if (locale.startsWith('el')) {
      const translation = elTranslations[normalizedText];
      // If there is no translation, we just return the text as is.
      if (translation == null) return text;
      return translation;
    }
    return text;
  }, [locale]);

  return { t: tFn };
};

const L = ({ text, isToken = false }) => {
  const { t } = useTranslation();
  const { translate } = useTokenTranslate();

  // First we have to handle non-text cases.
  if (text == null) return null;

  if (typeof text !== 'string') {
    // There is a special case, if we were to receive a React children object
    // with a single text element inside it.
    try {
      const count = React.Children.count(text);
      if (count !== 1) return text;
      let result = null;
      let good = false;
      React.Children.forEach(text, (child) => {
        if (typeof child === 'string') {
          result = <L text={child} />;
          good = true;
        }
      });
      if (good) return result;
    } catch (_) { /* No action is required at this point. */ }

    // If the type of text is not a string, then we should just return as is.
    return text;
  }
  // this is temporary until we eliminate the use of old translations completely
  if (isToken) return translate(text);

  return t(text);
};

export default L;
